import React, { useState } from "react";
import cx from "classnames";
import Photo from "@components/photo";
import Phrase from "@components/phrase";
import Accordion from "@components/accordion";
import BlockContent from "@components/block-content";

const Expanders = ({ data = {} }) => {
  const { phrase, image, introText, expanders } = data;
  const [activeAccordions, setActiveAccordions] = useState([]);
  const addOrRemove = (arr, item) =>
    arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item];

  const onToggle = (id, status) => {
    setActiveAccordions(addOrRemove(activeAccordions, id));
  };

  return (
    <section
      className={cx(
        "expanders",
        "p-4",
        "md:p-10",
        "py-20",
        "relative",
        "z-0",
        "bg-gray"
      )}
    >
      <div
        className={cx(
          "grid",
          "grid-cols-1",
          "md:grid-cols-20",
          "site-container"
        )}
      >
        {phrase && (
          <div
            className={cx(
              "col-span-1",
              "md:col-span-12",
              "md:col-start-5",
              "text-center",
              "py-5"
            )}
          >
            {image && (
              <div
                className={cx(
                  "mt-10",
                  "mb-[-78px]",
                  "mx-auto",
                  "w-full",
                  "max-w-[70%]",
                  "md:max-w-[500px]"
                )}
              >
                <Photo photo={image} width={1200} layout="intrinsic" />
              </div>
            )}
            <div className={cx("mt-10", "mb-3", "mx-auto", "relative", "z-10")}>
              <Phrase
                phrase={phrase}
                typeStyle={"text-lg-1-mobile md:text-lg-1"}
                dividerMaxWidth="50vw"
                reverse={true}
              />
            </div>
          </div>
        )}

        {introText && (
          <div
            className={cx(
              "col-span-1",
              "md:col-span-10",
              "md:col-start-6",
              "text-center",
              "py-5",
              "mb-10",
              "text-large",
              "font-sansRegular"
            )}
          >
            <BlockContent blocks={introText} />
          </div>
        )}
        <div className={cx("col-span-1", "md:col-span-14", "md:col-start-4")}>
          {expanders.map((expander, idx) => {
            let title = "";
            if (expander.sublabel && !expander.label) {
              title = (
                <div className="text-subheader-2 leading-[1.3] uppercase font-sansRegular">
                  {expander.sublabel}
                </div>
              );
            }
            if (expander.label) {
              title = (
                <div className="text-subheader-2 leading-[1.3] uppercase font-sansRegular">
                  {expander.label}
                </div>
              );
              if (expander.sublabel) {
                title = (
                  <div>
                    <div className="text-caption uppercase font-sansRegular tracking-[0.18em]">
                      {expander.sublabel}
                    </div>
                    <div className="text-lg-3">{expander.label}</div>
                  </div>
                );
              }
            }

            return (
              <Accordion
                key={idx}
                title={title}
                id={`expanders-dropdown-${idx}`}
                isOpen={
                  activeAccordions.indexOf(`expanders-dropdown-${idx}`) > -1
                    ? true
                    : false
                }
                onToggle={onToggle}
              >
                {expander.body && (
                  <div
                    className={cx(
                      "text",
                      "p-4",
                      "text-large",
                      "font-sansRegular",
                      "tracking-[0.0em]",
                      "md:max-w-[80%]"
                    )}
                  >
                    <BlockContent blocks={expander.body} />
                  </div>
                )}
                {expander.specs && (
                  <div
                    className={cx(
                      "text",
                      "sm:w-1/2",
                      "sm:ml-auto",
                      "pl-5",
                      "sm:pl-0",
                      "pr-4",
                      "my-2"
                    )}
                  >
                    {expander.specs.map((spec, idx) => (
                      <div key={idx} className={cx("mb-5")}>
                        {spec.title && (
                          <div
                            className={cx(
                              "text-subheader",
                              "font-sansSemiBold",
                              "mb-1"
                            )}
                          >
                            {spec.title}
                          </div>
                        )}
                        {spec.text && (
                          <div
                            className={cx(
                              "text-large",
                              "font-sansRegular",
                              "mb-1"
                            )}
                            dangerouslySetInnerHTML={{
                              __html: spec.text.replace(/\n/g, "<br />"),
                            }}
                          ></div>
                        )}
                        {spec.part && (
                          <div
                            className={cx(
                              "text-caption",
                              "font-sansRegular",
                              "uppercase",
                              "opacity-50"
                            )}
                          >
                            {spec.part}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </Accordion>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Expanders;
